
import { FilterMatchMode, FilterOperator } from "primevue/api";
import axios from "axios";
import { useCookies } from "vue3-cookies";

const { cookies } = useCookies();

export default {
  data() {
    return {
      gateGalleryList          : null,
      filters1                 : null,
      loading                  : true,
      gateCategory             : [],
      worksCategory            : [],
      mediaCategory            : [],
      gateGallery              : {
        gateGalleryId: ""
      },
      displayConfirmation      : false,
      images                   : [],
      visibleImageGallery      : false,
      galleriaResponsiveOptions: [
        {
          breakpoint: "1024px",
          numVisible: 5
        }
      ]
    };
  },
  created() {
    this.initFilters1();
  },
  async mounted() {
    await this.searchGateGalleryList();
    this.loading = false;
  },
  methods: {
    searchGateGalleryList() {
      const _this = this;
      axios.post("/api/gate-gallery/all", "", {
        headers: { "Authorization": `Bearer ${cookies.get("Authentication")}` }
      }).then(function(response) {
        if (response.data.success === 200) {
          _this.gateGalleryList = response.data.resp.gateGalleryList;
          _this.gateGalleryList.forEach(gallery => gallery.crtDate = new Date(gallery.crtDate));
          _this.gateCategory = response.data.resp.gateCategory;
          _this.worksCategory = response.data.resp.worksCategory;
          _this.mediaCategory = response.data.resp.mediaCategory;
        }
      }).catch(function(err) {
        console.log(err);
        _this.showToast("error", "조회 실패", "게시물 조회에 실패하였습니다.\n관리자에게 문의 바랍니다.");
      });
    },
    clearFilter1() {
      this.initFilters1();
    },
    initFilters1() {
      this.filters1 = {
        "global"       : { value: null, matchMode: FilterMatchMode.CONTAINS },
        "gateTypeName" : { value: null, matchMode: FilterMatchMode.IN },
        "gateWorksName": { value: null, matchMode: FilterMatchMode.IN },
        "mediaTypeName": { value: null, matchMode: FilterMatchMode.IN },
        "galleryTitle" : {
          operator   : FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
        },
        "crtId"        : {
          operator   : FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
        },
        "crtDate"      : {
          operator   : FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
        }
      };
    },
    formatDate(value) {
      return value.toLocaleDateString("ko-KR", {
        year : "numeric",
        month: "2-digit",
        day  : "2-digit"
      });
    },
    openDeleteConfirmation(galleryId) {
      this.displayConfirmation = true;
      this.gateGallery.gateGalleryId = galleryId;
    },
    deleteGateGallery() {
      const _this = this;
      axios.post("/api/gate-gallery/delete", this.gateGallery, {
        headers: { "Authorization": `Bearer ${cookies.get("Authentication")}` }
      }).then(function(response) {
        if (response.data.success === 200) {
          _this.searchGateGalleryList();
          _this.showDeleteSuccessToast();
          _this.closeConfirmation();
        }
      }).catch(function(err) {
        console.log(err);
        _this.showToast("error", "삭제 실패", "게시물 삭제에 실패했습니다.\n관리자에게 문의 바랍니다.");
      });
      this.closeConfirmation();
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    showDeleteSuccessToast() {
      this.$toast.add({ severity: "success", summary: "삭제", detail: "완료되었습니다.", life: 3000 });
    },
    viewGalleryDetail(galleryId) {
      this.$router.push({ name: "GateGalleryForm", params: { galleryId } });
    },
    showToast          : function(toastType, message, description) {
      this.$toast.add({ severity: toastType, summary: message, detail: description, life: 3000 });
    },
    displayImageGallery: async function(gateGalleryId) {
      const _this = this;
      await axios.post("/api/gate-gallery-item/list", { "gateGalleryId": gateGalleryId }, window.axiosOptions)
        .then(function(response) {
          if (response.data.success === 200) {
            _this.images = response.data.resp;
          }
        }).catch(function(err) {
          console.error(err);
          _this.showToast("error", "게시물 조회 실패", "게시물 조회에 실패했습니다.\n관리자에게 문의 바랍니다.");
        });

      this.visibleImageGallery = true;
    }
  }
};
